import React, { useEffect, useState, useMemo } from "react";
import logo from "../assets/iconos/profile.png";
import avatarNeutro from "../assets/iconos/avatar_neutro.png";
import useMatricula from "../hooks/useMatricula";
import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import { apiFotoEstudiante } from "../config/constantes";
import { medirBackend, medirFrontendRender } from "../utils/performance/perfTracker";

const Card = () => {
  const { obtenerDatosEstudiante } = useMatricula();
  const { listadoEtiquetas } = useAuth();
  const [imgSucces, setImgSucces] = useState(true);
  const [fotoEstudiante, setFotoEstudiante] = useState(null);
  const [loadingFoto, setLoadingFoto] = useState(false);

  const etiquetas = useMemo(() => {
    if (!listadoEtiquetas || listadoEtiquetas.length === 0) return {};
    return {
      global_dni: obtenerLabelEtiqueta("lbl_global_dni", listadoEtiquetas),
      global_cod: obtenerLabelEtiqueta("lbl_global_cod", listadoEtiquetas),
      global_ciclo: obtenerLabelEtiqueta("lbl_global_ciclo", listadoEtiquetas),
      home_programa: obtenerLabelEtiqueta("lbl_home_programa", listadoEtiquetas),
      home_plan_estudio: obtenerLabelEtiqueta("lbl_home_plan_estudio", listadoEtiquetas),
      global_tutor: obtenerLabelEtiqueta("lbl_global_tutor", listadoEtiquetas),
    };
  }, [listadoEtiquetas]);

  const {
    dpersona, dprograma, dperiodo, cfoto, dciclo, nivelformacion,
    ndocidentidad, dcurricula, franja, convenio_beca, categoria,
    sprograma, dcondicion, dfacultad, dmodalidad
  } = obtenerDatosEstudiante || {};

  useEffect(() => {
    if (!ndocidentidad) return; // obtenerDatosEstudiante todavía no cargó: evita el fetch con id vacío

    const idBusqueda = [ndocidentidad];

    const controller = new AbortController();
    const signal = controller.signal;

    const obtenerFoto = async () => {
      setLoadingFoto(true);
      
      try {
        const tokenGloString = localStorage.getItem("tokenGlo");
        if (!tokenGloString) throw new Error("No token found");

        const tokenGlo = JSON.parse(tokenGloString);
        const accessToken = tokenGlo?.access_token;

        if (!accessToken) throw new Error("No access token");

        
        const urlWithParams = `${apiFotoEstudiante}${idBusqueda}`; 
        
        console.log(` Fetching foto para: ${idBusqueda}`);

        const response = await medirBackend(
          "inicio_foto_persona",
          "Foto de perfil (fotoPersona)",
          "Inicio",
          () =>
            fetch(urlWithParams, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`,
              },
              signal: signal,
            })
        );

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();

        if (data.StatusCode === 200 && data.Code) {
          const inicioRender = performance.now();
          setFotoEstudiante(data.Code);
          setImgSucces(true);
          medirFrontendRender("inicio_foto_persona_render", "Foto de perfil - render", "Inicio", inicioRender);
        } else {
          console.warn(" API respondió pero sin URL válida:", data);
        }

      } catch (error) {
        if (error.name !== 'AbortError') {
            console.error(" Error obteniendo foto:", error.message);
        }
      } finally {
        if (!signal.aborted) {
            setLoadingFoto(false);
        }
      }
    };

    obtenerFoto();

    return () => controller.abort();

  }, [ndocidentidad]);


  const getImagenPerfil = () => {
    if (fotoEstudiante && imgSucces) return fotoEstudiante;
    if (cfoto && !String(cfoto).includes("url") && cfoto !== null && imgSucces) return cfoto;
    return avatarNeutro;
  };

  return (
    <div className="card card-profile shadow-sm">
      <div className="card-header"></div>
      <div className="card-body">
        <div className="profile-info text-center">
          
          {loadingFoto ? (
            <div 
              className="rounded-circle shadow-sm my-3 d-flex align-items-center justify-content-center mx-auto"
              style={{ width: "100px", height: "100px", backgroundColor: "#f0f0f0" }}
            >
              <span className="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
            </div>
          ) : (
            <img
              src={getImagenPerfil()}
              onError={(e) => {
        
                e.target.onerror = null; 
                setImgSucces(false);
              }}
              className="rounded-circle shadow-sm my-3 bg-white"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
              alt="Foto de perfil"
            />
          )}

          <p className="fw-bolder mb-2 text-center">{dpersona}</p>
          <span className="text-uppercase badge-secondary">
            {nivelformacion}
          </span>

          <div className="student-info-1 mt-3 d-flex flex-wrap justify-content-around">
            <p className="mb-0 fs-13">
              <span className="text-upch">
                <i className="bi bi-mortarboard" />
              </span>
              <span className="fw-medium ms-1">{dmodalidad}</span>
            </p>
            <p className="mb-0 fs-13">
              <span className="text-upch">
                <i className="bi bi-person-vcard" />
              </span>
              <span className="fw-medium ms-1">{ndocidentidad}</span>
            </p>
          </div>

          <div className="text-center mt-2">
            <p className="mb-0 text-uppercase fw-medium mb-2 fs-13 text-center">
              {sprograma && `[${sprograma}] `}{dprograma}
            </p>
            <p className="mb-0 text-uppercase fw-medium mb-2 fs-13 text-center">
              {dfacultad}
            </p>
          </div>

          <div className="student-info-2 text-start mt-3 border-top p-3 pb-2">
            <div className="row g-2">
                <div className="col-4">
                    <p className="mb-0 fs-14">
                        <span className="fw-medium">{etiquetas.global_ciclo || "Ciclo"}:</span><br /> {dciclo}
                    </p>
                </div>
                <div className="col-4">
                    <p className="mb-0 fs-14">
                        <span className="fw-medium">Plan:</span><br /> {dcurricula}
                    </p>
                </div>
                <div className="col-4">
                    <p className="mb-0 fs-14">
                        <span className="fw-medium">Período:</span><br /> {dperiodo}
                    </p>
                </div>
                <div className="col-4">
                     <p className="mb-0 fs-14">
                        <span className="fw-medium">Franja:</span><br /> {franja}
                    </p>
                </div>
                <div className="col-4">
                    <p className="mb-0 fs-14">
                        <span className="fw-medium">Beca:</span><br /> {convenio_beca}
                    </p>
                </div>
                 <div className="col-4">
                    <p className="mb-0 fs-14">
                        <span className="fw-medium">Categoría:</span><br /> {categoria}
                    </p>
                </div>
                 <div className="col-12">
                    <p className="mb-0 fs-14">
                        <span className="fw-medium">Condición:</span><br /> {dcondicion}
                    </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;